import { Component} from '@angular/core';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'spinner-window',
    templateUrl: './spinner-window.component.html',
    standalone: true,
    imports: [ProgressSpinnerModule]
})
export class SpinnerWindowComponent{
  constructor(public loader: LoaderFactory) {}
}
